// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import draftVersionEntity from './entities/draft-version.json';
import draftVersionMenu from '../pages/draft-version/menu.json';
import draftVersionFullForm from '../pages/draft-version/forms/full.json';
import draftVersionContextForm from '../pages/draft-version/forms/context.json';
import draftVersionMiniForm from '../pages/draft-version/forms/mini.json';
import draftVersionLookupForm from '../pages/draft-version/forms/lookup.json';
import draftVersionTableView from '../pages/draft-version/views/table.json';
import draftVersionCardsView from '../pages/draft-version/views/cards.json';
import draftVersionDashboardView from '../pages/draft-version/views/dashboard.json';

/** Тип запису «Версія проєкту» зі сторінками пакета: меню, форми та подання з pages/draft-version/. */
export const draftVersionDefinition: IRecordTypeDefinition = {
  ...draftVersionEntity,
  views: assembleViewSet({
      table: draftVersionTableView,
      cards: draftVersionCardsView,
      dashboard: draftVersionDashboardView,
  }),
  form: draftVersionFullForm,
  forms: { full: draftVersionFullForm, context: draftVersionContextForm, mini: draftVersionMiniForm, lookup: draftVersionLookupForm },
  menu: draftVersionMenu,
} as IRecordTypeDefinition;
